import React from 'react';

interface IconDollarProps {
    iconClasses?: string;
}

const IconDollar: React.FC<IconDollarProps> = ({ iconClasses }) => {
    return (
        <svg
            width="9"
            height="13"
            viewBox="0 0 9 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-dollar ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M4.08203 0V12.8333"
                stroke="currentColor"
                strokeWidth="1.16667"
            />
            <path
                d="M6.9987 2.33333H2.6237C2.08221 2.33333 1.56291 2.54844 1.18002 2.93132C0.797135 3.31421 0.582031 3.83352 0.582031 4.375C0.582031 4.91648 0.797135 5.43579 1.18002 5.81867C1.56291 6.20156 2.08221 6.41667 2.6237 6.41667H5.54036C6.08185 6.41667 6.60115 6.63177 6.98404 7.01466C7.36693 7.39754 7.58203 7.91685 7.58203 8.45833C7.58203 8.99982 7.36693 9.51912 6.98404 9.90201C6.60115 10.2849 6.08185 10.5 5.54036 10.5H0.582031"
                stroke="currentColor"
                strokeWidth="1.16667"
            />
        </svg>
    );
};

export default IconDollar;
